module.exports = __webpack_public_path__ + "img/ca.b970b579.png";